import styled, { css } from 'styled-components'

import { BRAND } from 'constants/appConstants'
import { theme } from 'utils/theme'

export const ButtonContainer = styled.div`
  .btn {
    font-family: ${({ theme: { brand } }) => (brand === BRAND.ATH ? 'AzoSans' : 'Futura Std')};
    letter-spacing: ${({ theme: { brand } }) => brand === BRAND.GCAD && '0.03em'};
    width: ${({ width }) => width ?? 'auto'};
    height: 40px;
    align-items: center;
    border-radius: 50px;
    border: none;
    display: flex;
    ${({ iconLeft }) => iconLeft && 'flex-direction:row-reverse;'}
    justify-content: ${({ icon }) => (icon ? 'space-between' : 'center')};
    margin: 0;
    font-size: ${({ fontSize }) => fontSize};
    font-weight: ${({ fontWeight }) => fontWeight};
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : '1')};

    p {
      display: inline-block;
      margin: 0;
    }

    .icon-container {
      ${({ iconLeft }) => (!iconLeft ? 'margin-left: 20px;' : 'margin-right: 20px;')}
    }

    &.btn-default {
      background: ${({ theme: { brand } }) =>
        brand === BRAND.ATH ? theme.colors.primaryRed : theme.colors.gcadOrange};
      color: ${theme.colors.white};
      padding: 0 20px;

      p {
        color: ${theme.colors.white};
      }

      .icon {
        fill: ${theme.colors.white};
      }
    }

    &.btn-filter {
      padding: 9px 16px;

      ${({ theme: { brand } }) =>
        brand === BRAND.ATH
          ? css`
              background: ${props => (props.selected ? theme.colors.lightGold : theme.colors.white)};
              color: ${theme.colors.black};
              border: 1px solid ${theme.colors.lightGold};
            `
          : css`
              background: ${props => (props.selected ? theme.colors.gcadOrange : 'transparent')};
              color: ${theme.colors.white};
              border: ${props => !props.selected && `3px solid ${theme.colors.white}`};
            `}

      p {
        font-size: 16px;
        font-weight: 600;
        line-height: 21px;
      }
    }

    &.btn-search {
      border-radius: 50%;
      padding: 0;
      width: 50px;
      height: 50px;
      background: ${theme.colors.primaryRed};
      color: ${theme.colors.white};

      p {
        color: ${theme.colors.white};
      }

      .icon-container {
        margin: 0;
        width: 20px;
        height: 20px;

        .icon {
          width: 20px;
          height: 20px;
          fill: ${theme.colors.white};
        }
      }
    }

    &.btn-icon {
      background: ${({ theme: { brand } }) =>
        brand === BRAND.ATH ? theme.colors.primaryRed : theme.colors.gcadOrange};
      color: ${theme.colors.white};
      padding: 17px 24px;
      height: 64px;

      .icon {
        path {
          fill: ${({ theme: { brand } }) => (brand === BRAND.ATH ? theme.colors.lightGold : theme.colors.white)};
        }
      }

      &.transparent {
        background: transparent;
        border: 2px solid ${theme.colors.white};
      }
    }
  }
`
